import React from "react";
import Marquee from "react-fast-marquee";

interface Props {
  cover?: string;
  coverTrack?: string;
  trackName?: string;
  artist?: string;
}

const InfoTrack: React.FC<Props> = ({
  cover,
  coverTrack,
  trackName,
  artist,
}) => {
  return (
    <>
      <div className="flex w-full">
        <div className="pr-2 py-2 ">
          <div className="max-w-[3rem] min-w-[3rem] max-h-[3rem] min-h-[3rem] h-full flex justify-start items-center overflow-hidden rounded-md">
            {coverTrack ? (
              <img
                className="w-full h-full object-cover"
                src={coverTrack}
                alt="cover"
              />
            ) : (
              <img
                className="w-full h-full object-cover"
                src={cover}
                alt="cover"
              />
            )}
          </div>
        </div>
        <div className="flex items-center min-w-[80px] max-w-[80px]">
          <div>
            <h4
              className={`min-w-[5rem] max-w-[10rem] text-base font-semibold text-ellipsis overflow-hidden whitespace-nowrap md:text-lg`}
            >
              {trackName && (
                <span>
                  {trackName.length > 15 ? (
                    <Marquee
                      pauseOnHover={true}
                      speed={20}
                      style={{ width: "100%" }}
                    >
                      <span className="pr-5">{trackName}</span>
                      <span className="pr-5">{trackName}</span>
                      <span className="pr-5">{trackName}</span>
                    </Marquee>
                  ) : (
                    <>{trackName}</>
                  )}
                </span>
              )}
            </h4>
            <p className="min-w-[5rem] max-w-[10rem] text-[13px] text-ellipsis overflow-hidden whitespace-nowrap">
              {artist && (
                <span>
                  {artist.length > 15 ? (
                    <Marquee
                      pauseOnHover={true}
                      speed={20}
                      style={{ width: "100%" }}
                    >
                      <span className="pr-5">{artist}</span>
                      <span className="pr-5">{artist}</span>
                      <span className="pr-5">{artist}</span>
                    </Marquee>
                  ) : (
                    <>{artist}</>
                  )}
                </span>
              )}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfoTrack;
